
import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { InputGroup, Form } from 'react-bootstrap';
import { Button } from '@/shared/components/Button';
import Pagination from 'react-bootstrap/Pagination';
import toast from 'react-hot-toast';
import { FaArrowUpShortWide, FaArrowDownWideShort } from 'react-icons/fa6';
import { AuthContext } from '../../../../../../context/AuthContext';
import { GlobalContext } from '../../../../../../context/GlobalContext';
import { SideBarRefreshContext } from '../../../../../../context/SideBarRefreshContext';

const DataReactTable = () => {
  const [pendingData, setPendingData] = useState([]);
  const [filteredBookingData, setFilteredBookingData] = useState([]);
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [refresh, setRefresh] = useState(false);
  const { apiGlobal } = useContext(GlobalContext);
  const { agentId, countryId } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  // Fetch data from API
  const fetchPendingData = async () => {
    const formData = new FormData();
    formData.append('agent_id', agentId);
    formData.append('country_id', countryId);
    try {
      const url = await fetch(`${apiGlobal}/agent/account_pending_list.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        setPendingData(data.data);
      } else {
        setPendingData([]);
        console.error(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPendingData();
  }, [refresh, sideBarRefresh?.agentpendingRefresh]);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  // Apply filters when date range changes
  useEffect(() => {
    let filteredData = [...pendingData];

    if (searchStartDate) {
      filteredData = filteredData.filter((trip) => {
        const tripPaymentDate = new Date(trip.payment_date); // ✅ FIXED
        return tripPaymentDate.getTime() === new Date(searchStartDate).getTime();
      });
    }

    // if (searchEndDate) {
    //   filteredData = filteredData.filter(trip => new Date(trip.end_date) <= new Date(searchEndDate));
    // }

    setFilteredBookingData(filteredData);
    setCurrentPage(1); // Reset to first page on filter change
  }, [searchStartDate, pendingData]);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBookingData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredBookingData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

   const [sortOrder, setSortOrder] = useState('asc');
    const [sortColumn, setSortColumn] = useState('payment_date'); // This will track the column being sorted
     
    const handleSort = (column) => {
      const newSortOrder = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
    
      const sortedData = [...filteredBookingData].sort((a, b) => {
        if (column === 'payment_date') {
          return newSortOrder === 'asc'
            ? new Date(a.payment_date) - new Date(b.payment_date)
            : new Date(b.payment_date) - new Date(a.payment_date);
            // eslint-disable-next-line
        } else if (column === 'balance') {
          return newSortOrder === 'asc'
            ? parseFloat(a.balance) - parseFloat(b.balance)
            : parseFloat(b.balance) - parseFloat(a.balance);
        } else if (column === 'status') {
          return newSortOrder === 'asc' ? a.status.localeCompare(b.status) : b.status.localeCompare(a.status);
        }
        return 0;
      });
    
      setFilteredBookingData(sortedData); // Ensure UI updates correctly
      setSortOrder(newSortOrder);
      setSortColumn(column);
    };

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>


        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchStartDate('');
            setSearchEndDate('');
          }}
        >
          Clear Filters
        </Button>
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setRefresh(prev => !prev);
            toast.success('Data Refreshed Successfully');
          }}
        >
          Refresh
        </Button>
      </div>

      {/* Data Table */}
      <Table
        responsive
        style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead className="bg-primary" style={{ color: 'white', textAlign: 'center' }}>
          <tr>
            <th>#</th>
            <th onClick={() => handleSort('payment_date')} style={{ cursor: 'pointer' }}>
              Payment Date {sortColumn === 'payment_date' 
              && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
            </th>
            <th onClick={() => handleSort('balance')} style={{ cursor: 'pointer' }}>
              Booking Amount {sortColumn === 'balance' 
              && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
            </th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                <h3>No Pending Data Available</h3>
              </td>
            </tr>
          ) : (
            currentItems.map((booking, index) => (
              <tr
                key={booking.id}
                style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f2f2f2', textAlign: 'center' }}
              >
                <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                <td>{formatDate(booking.payment_date)}</td>
                <td>{booking.balance}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </div>
  );
};

export default DataReactTable;
